/* 壹品 商品頁固定底部購買列（<750px）
   - 不自己送表單：兩顆按鈕都觸發主表單的加入按鈕 .click()，變體／數量／售罄／GTM 事件全部沿用 product-form.js
   - 立即購買：訂閱 cartUpdate（product-form 加入成功後才發布）→ 前往 /cart；絕不直接進結帳（Ako 超商／發票在購物車頁）
   - 顯示時機：IntersectionObserver 看主按鈕，離開畫面才滑出；狀態（停用／文字／loading）用 MutationObserver 同步 */
(function () {
  class EepiBuybar extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById('ProductSubmitButton-' + this.dataset.section);
      this.addBtn = this.querySelector('[data-eepi-add]');
      this.buyBtn = this.querySelector('[data-eepi-buy]');
      if (!this.main || !this.addBtn || !this.buyBtn) {
        this.remove();
        return;
      }
      this.buyNow = false;

      this.addBtn.addEventListener('click', () => this.main.click());
      this.buyBtn.addEventListener('click', () => {
        if (this.isMainDisabled()) return;
        this.buyNow = true;
        document.body.classList.add('eepi-buynow'); /* 導向前先藏住加入通知，避免閃一下 */
        this.main.click();
      });

      this.unsubscribers = [
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (this.buyNow && event.source === 'product-form') window.location.assign(window.routes.cart_url);
        }),
        subscribe(PUB_SUB_EVENTS.cartError, () => {
          this.resetBuyNow();
          setTimeout(() => {
            var error = document.querySelector('#MainProduct-' + this.dataset.section + ' .product-form__error-message-wrapper:not([hidden])');
            if (error) error.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }, 0);
        }),
        subscribe(PUB_SUB_EVENTS.variantChange, () => this.sync()),
      ];
      this.onPageShow = (event) => {
        if (event.persisted) this.resetBuyNow(); /* 從購物車頁按返回（bfcache）時重置 */
      };
      window.addEventListener('pageshow', this.onPageShow);

      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.main, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
        characterData: true,
      });

      /* 主按鈕被購買列蓋住（畫面底部 64px 內）也算離開畫面 */
      this.io = new IntersectionObserver((entries) => this.toggle(!entries[0].isIntersecting), { rootMargin: '0px 0px -64px 0px' });
      this.io.observe(this.main);
      this.sync();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.observer) this.observer.disconnect();
      if (this.unsubscribers) this.unsubscribers.forEach((unsubscribe) => unsubscribe());
      window.removeEventListener('pageshow', this.onPageShow);
      this.resetBuyNow();
    }

    isMainDisabled() {
      return this.main.disabled || this.main.getAttribute('aria-disabled') === 'true';
    }

    resetBuyNow() {
      this.buyNow = false;
      document.body.classList.remove('eepi-buynow');
    }

    toggle(show) {
      this.classList.toggle('is-visible', show);
      this.inert = !show;
    }

    sync() {
      var disabled = this.isMainDisabled();
      var label = this.main.querySelector('span:not(.hidden):not(.loading__spinner)');
      var text = label ? label.textContent.trim() : '';
      this.addBtn.disabled = disabled;
      this.buyBtn.disabled = disabled;
      if (text) this.addBtn.textContent = text;
      this.classList.toggle('is-loading', this.main.classList.contains('loading'));
    }
  }

  if (!customElements.get('eepi-buybar')) customElements.define('eepi-buybar', EepiBuybar);
})();
